export default __webpack_public_path__ + "static/O0136-a654fe6e6fb6f49be3748bca83d61e3b.png";